export default "__VITE_ASSET__BI0h2cda__"